import { randomString } from './index';
import { setCookie, getCookie } from './cookie';

class ScTrack {
    constructor() {
        this.instance = null;
        this.trackInstance = null;
        this.fingerprintId = '';

        this.init();
    }

    static getInstance(options = {}) {
        if (!this.instance) {
            this.instance = new ScTrack(options);
        }
        return this.instance;
    }

    init() {
        this.getFingerprintId();
        // eslint-disable-next-line
        if (!jftrack) return;
        // eslint-disable-next-line
        this.trackInstance = new jftrack({
            debugger: process.env.NODE_ENV !== 'production',
            server_url: 'https://jc-sensors.9fapi.com/sa',
            userName: this.fingerprintId || '9fztgw',
            platForm: '9fztgw',
            project:
                process.env.NODE_ENV !== 'production'
                    ? 'rjhy_huntianling_test'
                    : 'ytx_xinlanghuixuangu',
        });
    }

    track(eventName, props = {}) {
        if (!this.trackInstance) return;
        this.trackInstance.track(
            eventName,
            Object.assign(
                {
                    server_id: 200,
                    platform_id: '9fztgw',
                    front_type: 'wap',
                    project_id: 'ytx_jfztgw',
                    computer_id: this.fingerprintId,
                },
                props,
            ),
        );
    }

    getFingerprintId() {
        let fingerprintId = getCookie('fingerprintId');
        if (!fingerprintId) {
            fingerprintId = +new Date() + randomString(4);
        }
        setCookie('fingerprintId', fingerprintId, 7);
        this.fingerprintId = fingerprintId;
    }
}

export default ScTrack;
